import {main as UserTypeEnum} from '../enums/UserType';
import {main as MessageEventEnum} from '../enums/MessageEvent';

export const PopupLogin = class PopupLogin {
    constructor(authSvcDomain) {
        this.authSvcDomain = authSvcDomain;
        this.loginPopupWindow = undefined;
        this.authTokenResolve = undefined;

        this.onWindowMessageReceive = this.onWindowMessageReceive.bind(this);

        this.messageEventMap = new Map()
            .set(
                MessageEventEnum.AUTH_LOGIN_READY,
                {
                    handler: this.onAuthLoginReadyEventReceive.bind(this),
                }
            )
            .set(
                MessageEventEnum.UPDATE_AUTH_TOKEN,
                {
                    handler: this.onUpdateAuthTokenEventReceive.bind(this),
                }
            );
    }

    process(userTypeEnum, windowOptions = {}) {
        if (!UserTypeEnum.isDefined(userTypeEnum)) {
            throw new TypeError('Invalid user type');
        }

        const loginPopupWindow = window.open(
            this.getPopupWindowUrl(userTypeEnum.key.toLowerCase()),
            '_blank',
            Object.entries(this.getPopupWindowOptions(windowOptions))
                .map(entry => entry.join('='))
                .join(','),
        );

        this.loginPopupWindow = loginPopupWindow;

        loginPopupWindow.focus();

        return new Promise(resolve => {
            this.authTokenResolve = resolve;

            window.addEventListener('message', this.onWindowMessageReceive);
        });
    }

    hasActivePopupWindow() {
        const {loginPopupWindow} = this;

        return loginPopupWindow && !loginPopupWindow.closed;
    }

    getPopupWindowUrl(userType) {
        return `${this.authSvcDomain}/auth/${userType}/login?loginFlow=POPUP`;
    }

    getPopupWindowOptions(windowOptions = {}) {
        const {authSvcDomain, userType} = this;
        const {width: scrWidth, height: scrHeight} = window.screen;
        const width = 360;
        const height = 600;
        const left = (scrWidth - width) / 2;
        const top = (scrHeight - height) / 2;

        return Object.assign(
            {
                toolbar: 0,
                status: 0,
                menubar: 0,
                scrollbars: 0,
                width,
                height,
                left,
                top,
            },
            windowOptions
        );
    }

    onWindowMessageReceive(event) {
        const eventType = MessageEventEnum.get(event.data.event);

        if (!eventType) {
            return;
        }

        const {handler} = this.messageEventMap.get(eventType) || {};

        if (!handler) {
            return;
        }

        handler(event);
    }

    onAuthLoginReadyEventReceive({source}) {
        source.postMessage(
            {
                event: MessageEventEnum.CONFIRM_LOGIN_DOMAIN.key,
            },
            this.authSvcDomain
        );
    }

    onUpdateAuthTokenEventReceive(event) {
        window.removeEventListener('message', this.onWindowMessageReceive);

        this.loginPopupWindow.close();
        this.loginPopupWindow = undefined;

        this.authTokenResolve(event.data.data);
        this.authTokenResolve = undefined;
    }
};
